import React, { Component, Fragment } from 'react';
import { Switch,Tag, Button } from 'antd';
import SingleFilter from '../../components/FIlters/SingleFilter';
import CombinedFilter from '../../components/FIlters/CombinedFilter';
import PropTypes from 'prop-types';
import './DualAcetateFilter.css';
import SingleCigarette from '../../components/Cigarette/SingleCigarette';
import { connect } from 'react-redux';
import Translation from '../../Translation';

class AcetateFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDualFilter: false,
            isPaperGlueWt: true,
            combinedFilterData: [],
            saveCigRandomKey: '',
            dualFilterName: '',
            filterAName: null,
            filterBName: null,
            filter1Data: {},
            filter2Data: {},
            combFilterSectionData: {},
            showCigaretteDesign: false,
            combiData: {},
            filterData: [],
            dualFilterId: null,
            preferences: this.props.preferences,
            toFilterTowItemVal: this.props.toFilterTowItemVal || null,
            toFilterTowItemData: {
                tipsPerRod: 0,
                tipRodLength: 0,
                tipEpd: 0,
                pzLevel: this.getToFilterDataOnLoad('plasticizer'),
                cload: this.getToFilterDataOnLoad('carbonLoading'),
                tipCircumference: this.getToFilterDataOnLoad('circumference'),
                rangeLength: this.getToFilterDataOnLoad('towRange'),
                tipDiam: this.getToFilterDataOnLoad('diameter'),
                cRangeLength: this.getToFilterDataOnLoad('carbonRange'),
                plugwrapThickness: this.getToFilterDataOnLoad('plugwrapThicknessVal'),
                tipPgWt: this.getToFilterDataOnLoad('pgWeight'),
                newDpf: this.getToFilterDataOnLoad('dpf'),
                newTd: this.getToFilterDataOnLoad('td'),
                isCload: this.getToFilterDataOnLoad('isCarbonChecked'),
                carbonPir: this.getToFilterDataOnLoad('carbonPir'),
                isNewTowItemChecked: this.getToFilterDataOnLoad('isNewTowItemChecked'),
                isPaperGlue: this.getToFilterDataOnLoad('isPaperGlue'),
                isTowRange: this.getToFilterDataOnLoad('isTowRange'),
                isCarbonRange: this.getToFilterDataOnLoad('isCarbonRange'),
                isCapsule: this.getToFilterDataOnLoad('isCapsule'),
                capsuleMode: this.getToFilterDataOnLoad('capsuleMode'),
                capsuleWt: this.getToFilterDataOnLoad('capsuleWt'),
                capsulePd: this.getToFilterDataOnLoad('capsulePd'),
                capsuleNo: this.getToFilterDataOnLoad('capsuleNo')
            }
        };
    }
    componentWillMount() {
        const stateObj = this.props.location && this.props.location.state;
        let isDual = stateObj && this.props.location.state.filterType === 'dual' ? true : false;
        let towSelData = sessionStorage.getItem('towItemSelectionData');

        if (towSelData) {
            try {
                towSelData = JSON.parse(towSelData);
                if (towSelData.isPaperGlue) {
                    this.setState({
                        isPaperGlueWt: true
                    })
                } 
            } catch (e) {
                // do nothing
            }
        }

        this.checkFilterType(isDual);
        const stateObjData = stateObj && stateObj.toFilterTowItemData && Object.keys(stateObj.toFilterTowItemData).length ? stateObj.toFilterTowItemData : null;
        
        if(stateObj && stateObjData) {
            const tipsPerRod = parseInt(stateObj.tipsPerRod, 10);
            const tipRodLength = parseInt(stateObjData.length, 10)/tipsPerRod;
            const tipsEpd = parseInt(stateObjData.pressureDrop, 10)/tipsPerRod
            if(tipRodLength && tipsPerRod) {
                this.setState({
                    toFilterTowItemVal: stateObj.toFilterTowItemVal,
                    toFilterTowItemData: {
                        tipRodLength: tipRodLength,
                        tipsPerRod: tipsPerRod,
                        tipEpd: tipsEpd,
                        pzLevel: stateObjData.plasticizer,
                        cload: stateObjData.carbonLoading,
                        tipCircumference: stateObjData.circumference,
                        rangeLength: stateObjData.towRange,
                        tipDiam: stateObjData.diameter,
                        cRangeLength: stateObjData.carbonRange,
                        plugwrapThickness: stateObjData.plugwrapThicknessVal, 
                        tipPgWt: stateObjData.pgWeight,
                        newDpf: stateObj.isPredicted ? stateObjData.dpf : 0,
                        newTd: stateObj.isPredicted ? stateObjData.td : 0,
                        isCload: stateObjData.isCarbonChecked,
                        carbonPir: stateObjData.carbonPir,
                        isNewTowItemChecked: stateObj.isPredicted ? stateObjData.isNewTowItemChecked : false,
                        isPaperGlue: stateObjData.isPaperGlue,
                        isTowRange: stateObjData.isTowRange,
                        isCarbonRange: stateObjData.isCarbonRange,
                        isCapsule: typeof stateObjData.isCapsuleChecked === 'boolean' ? stateObjData.isCapsuleChecked : false,
                        capsuleMode: stateObjData.capsuleMode ? stateObjData.capsuleMode : '0',
                        capsuleWt: stateObjData.capsuleWt ? stateObjData.capsuleWt : 0,
                        capsulePd: stateObjData.capsulePd ? stateObjData.capsulePd : 0,
                        capsuleNo: stateObjData.capsuleNo ? stateObjData.capsuleNo : 0
                    }
                })
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        let locationObj = nextProps.location && nextProps.location.state ? nextProps.location.state : this.props.location;
        if(this.state.isDualFilter) {
            locationObj.filterType = 'dual';
            this.onChangeFilterType(true);
        } else {
            this.onChangeFilterType(false);
        }
        if(nextProps.carbonFiltersData) {
            this.setState({
                combinedFilterData: nextProps.carbonFiltersData
            })
        }
        if (this.props.preferences !== nextProps.preferences) {
            this.setState({
                preferences: nextProps.preferences
            });
        }
    }
    getToFilterDataOnLoad = (val) => {
        let toFilterItemData = this.props.toFilterTowItemData;
        let result;
        if(toFilterItemData) {
            if(val !== 'isNewTowItemChecked') {
                return toFilterItemData[val];
            }
            switch(val) {
                case 'isNewTowItemChecked': 
                    result = this.props.isPredicted ? toFilterItemData.isNewTowItemChecked : false;
                    break;
                default: break;
            }
            return result;
        }
    }
    checkFilterType=(isDualFilter)=> {
        if(isDualFilter) {
            this.onChangeFilterType(true);
        } else {
            this.onChangeFilterType(false);
        }
    }
    onChangeFilterType=(checked)=> {
        let obj = {
            isDualFilter: checked
        };
        if (!checked) {
            obj.combiData = {};
            obj.filter2Data = {};
            obj.filterBName = '';
        }
        this.setState(obj);
    }
    onChangePaperGlue=(checked)=> {
        this.setState({
            isPaperGlueWt: checked
        });
    }
    render() {
        return (
            <Fragment>
                <div className="dual-acetatefilter-wrapper">
                    {/* <BreadcrumbHeading heading={"Filter Design"} /> */}
                    <div className="acetatefilter-wrapper-header col-md-12">
                        <div className='filter-heading-wrapper'>
                            <h2><Translation labelName="title_filter_design" defaultText="Filter Design"/></h2>
                            <div className={ this.state.isDualFilter ? 'cigarette-image tow-images':'cigarette-image tow-images single'}>
                                <ul className="tow-images">
                                    <li><img alt='filter tip A' src="./images/tow.svg" /><span><Translation labelName="lbl_a" defaultText="A" /></span></li>
                                    <li className='orange-tip'><img alt='filter tip B' src="./images/orange_tip.svg" /><span><Translation labelName="lbl_b" defaultText="B" /></span></li>
                                    <li>
                                        <span className="cigarette-image-text"><Translation labelName="lbl_tobacco_column" defaultText="Tobacco Column" /></span>
                                        <img alt='cigarette' src='./images/cigarette-white.png' style={{width:'208px'}} />
                                    </li> 
                                </ul>
                            </div>
                            { this.state.preferences.kretek ? <Tag color="#f50" className='m1-left'><Translation labelName="hdr_kretek" defaultText="Kretek" /></Tag>: null }
                            { this.state.preferences.epdBias !== '' ? <Tag color="#f50" className='m1-left'><Translation labelName="lbl_epd_bias" defaultText="EPD Bias" /> :{this.state.preferences.epdBias}</Tag>: null }
                        </div>
                        <div className="dual-filter-props">
                            <label>
                                <Button icon="printer" type="primary" size="small" onClick={window.print}><Translation labelName="btn_print" defaultText="Print"/></Button>
                            </label>
                            <label> 
                                <Translation labelName="lbl_total_weight" defaultText="Total Weight"/>
                                <Switch size="small" checked={this.state.isPaperGlueWt} onChange={this.onChangePaperGlue} />
                            </label>
                            <label>
                                <Translation labelName="lbl_dual_filter" defaultText="Dual Filter"/>
                                <Switch size="small" checked={this.state.isDualFilter} onChange={this.onChangeFilterType} />
                            </label>
                            {/* <a href='/help/html/Filter_Design.htm' target="_blank" title="Help" className="help-section m2-left">
                                <img
                                    src="./images/help-inverse-black.svg"
                                    alt="help"
                                    className="help-icon" />
                            </a> */}
                        </div>
                    </div>
                </div>
                <div className={ this.state.isDualFilter ? "col-md-6 flush-left flush-right filter-main dual": 'col-md-12 flush-left flush-right filter-main single'}>
                    <div className='col-md-12 filter-segment'>
                        <h3><Translation labelName="sub_title_segment" defaultText="Segment"/></h3>
                        <ul className='tow-images'>
                            <li><img alt='filter tip A' src="./images/tow.svg" /><span><Translation labelName="lbl_a" defaultText="A" /></span></li>
                        </ul>
                    </div>
                    <SingleFilter key='segment-2'
                        isPaperGlueWt={this.state.isPaperGlueWt}
                        // isDualFilter={this.state.isDualFilter}
                        saveFiltersData={this.state.filterAName}
                        saveFiltersId={this.state.filterAId}
                        afterCalculate={ (filterData) => this.setState({'filter1Data':filterData})}
                        random={this.state.random}
                        saveRandomKey={this.state.saveRandomKey}
                        onChangePaperGlue={this.onChangePaperGlue}
                        reloadGraph={this.state.isDualFilter}
                        toFilterTowItemData={this.state.toFilterTowItemData}
                        toFilterTowItemVal={this.state.toFilterTowItemVal}
                    >
                    </SingleFilter>
                </div>
                { this.state.isDualFilter ? (<div className={ this.state.isDualFilter ? "col-md-6 flush-left flush-right filter-main dual": 'col-md-12 flush-left flush-right filter-main single'}>
                    <div className='col-md-12 filter-segment'>
                        <h3><Translation labelName="sub_title_segment" defaultText="Segment"/></h3>
                        <ul className="tow-images">
                            <li><img alt='filter tip B' src="./images/orange_tip.svg" /><span><Translation labelName="lbl_b" defaultText="B" /></span></li>
                        </ul>
                    </div>
                    <SingleFilter key='segment-1'
                        isPaperGlueWt={this.state.isPaperGlueWt}
                        saveFiltersData={this.state.filterBName}
                        saveFiltersId={this.state.filterBId}
                        isDualFilter={this.state.isDualFilter}
                        afterCalculate={ (filterData) => this.setState({'filter2Data':filterData})}
                        random={this.state.random}
                        saveRandomKey={this.state.saveRandomKey}
                        onChangePaperGlue={this.onChangePaperGlue}
                    >
                    </SingleFilter>
                </div>) : null }
                { this.state.isDualFilter ? (<div className="clearfix">
                    <CombinedFilter 
                        key="combi-fiter"
                        isPaperGlueWt={this.state.isPaperGlueWt}
                        // combinedFilter={this.state.combinedFilter}
                        dualFilterId={this.state.dualFilterId}
                        dualFilterName={this.state.dualFilterName}
                        combFilterSectionData={this.state.combFilterSectionData}
                        filter1Data={this.state.filter1Data}
                        filter2Data={this.state.filter2Data}
                        saveRandomKey={this.state.saveCigRandomKey}
                        performCalculate={()=>{this.setState({
                            random: (Math.random() * 20).toString()
                        })}}
                        performSave={()=>{this.setState({
                            saveRandomKey: (Math.random() * 20).toString()
                        })}}
                        performFilterChange={(obj)=>{
                            this.setState({
                                filterBName: obj.filterBName,
                                filterAName: obj.filterAName,
                                dualFilterName: obj.dualFilterName,
                                combFilterSectionData: obj.combFilterSectionData,
                                dualFilterId: obj.dualFilterId,
                                filterAId: obj.filterAId,
                                filterBId: obj.filterBId
                            });
                        }}
                        afterCalculate={(combiData) => this.setState({'combiData':combiData})}
                    ></CombinedFilter>
                </div>) : null }
                {/* { this.state.showCigaretteDesign ? <Fragment> */}
                <div className="cigarette-wrapper-header col-md-12">
                        <h2><Translation labelName="title_cigarette_design" defaultText="Cigarette Design"/></h2>
                        <div className={ this.state.isDualFilter ? 'cigarette-image':'cigarette-image single'}>
                            <ul className="tow-images">
                                <li><img alt='filter tip A' src="./images/tow.svg" /><span><Translation labelName="lbl_a" defaultText="A" /></span></li>
                                { this.state.isDualFilter ? <li className='orange-tip'> <img alt='filter tip B' src="./images/orange_tip.svg" /><span><Translation labelName="lbl_b" defaultText="B" /></span></li> : null }
                                <li>
                                    <span className="cigarette-image-text"><Translation labelName="lbl_tobacco_column" defaultText="Tobacco Column" /></span>
                                    <img alt='cigarette' src='./images/cigarette-white.png' style={{width:'208px'}} />
                                </li> 
                            </ul>
                        </div>
                        { this.state.preferences.kretek ? <Tag color="#f50" className='m1-left'><Translation labelName="hdr_kretek" defaultText="Kretek" /></Tag>: null }
                        {/* <a href='/help/html/Cigarette_Design.htm' title="Help" target="_blank" className="help-section">
                            <img
                                src="./images/help-inverse-black.svg"
                                alt="help"
                                className="help-icon" />
                        </a> */}
                    </div>
                    <div className="dual-acetatecigarette-wrapper">
                        <SingleCigarette
                            isDualCigarette={this.state.isDualFilter}
                            dualFilterId={this.state.dualFilterId}
                            dualFilterName={this.state.dualFilterName} 
                            filter1Data={this.state.filter1Data}
                            combiData={this.state.combiData}
                            performCalculate={()=>{this.setState({
                                random: (Math.random() * 20).toString()
                            })}}
                            performFilterChange={(obj)=>{
                                if(obj.isDualCigarette) {
                                    this.setState({
                                        dualFilterName: obj.data.dualFilterName,
                                        combFilterSectionData: obj.data,
                                        dualFilterId: obj.data.dualFilterId,
                                        filterAId: obj.data.filterAId,
                                        filterBId: obj.data.filterBId
                                    });
                                } else {
                                    this.setState({
                                        filterAName: obj.data.filterName,
                                        filterAId: obj.data.filterId
                                    });
                                }
                            }}
                            performSave={()=>{
                                let obj = {};
                                if (this.state.isDualFilter) {
                                    obj.saveCigRandomKey = (Math.random() * 20).toString();
                                } else {
                                    obj.saveRandomKey = (Math.random() * 20).toString();
                                }
                                this.setState(obj);
                            }}
                        />
                    </div>
                {/* </Fragment> : null } */}
            </Fragment>
        );
    }
}


const mapStateToProps = ({ loggedUserState,filtersState }) => ({
    filtersData: filtersState.filtersData,
    preferences: loggedUserState.prefData && loggedUserState.prefData.preferences,
    carbonFiltersData: filtersState.carbonFiltersData
});

export default connect(mapStateToProps, null)(AcetateFilter);

AcetateFilter.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    filtersData: PropTypes.array,
    preferences: PropTypes.object,
    carbonFiltersData: PropTypes.array,
    toFilterTowItemData: PropTypes.object,
    toFilterTowItemVal: PropTypes.string,
    isPredicted: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/containers/DualAcetateFilter/index.js